export const currencyConfig = {
    defaultCurrency: 'aed',
    supportedCurrencies: [
        { code: 'aed', label: 'AED' },
    ],
};
